export default {
    props: {
        schemaModel: {
            type: kendo.data.Node,
            kComposite: 'schema.model'
        }, 
        schemaModelHasChildren: {
            type: Boolean | String | Function,
            kComposite: 'schema.model.hasChildren'
        }, 
        schemaModelChildren: {
            type: String | Object,
            kComposite: 'schema.model.children'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoHierarchicalDataSource/Schema.js